import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "store/store";
import { API_ENDPOINTS } from "config/apiConfig";
import { axiosInstance } from "config/axiosConfig";
import { showLoading, hideLoading } from "./loadingSlice";
import { ConversationInquiryDetailParams } from "common/interfaces";

interface ConversationInquiryState {
  conversationInquiryData: any;
  conversationInquiryDetailData: ConversationInquiryDetailParams | null;
  error: string | null;
}

const initialState: ConversationInquiryState = {
  conversationInquiryData: null,
  conversationInquiryDetailData: null,
  error: null,
};

export const conversationInquirySlice = createSlice({
  name: "conversationInquiry",
  initialState,
  reducers: {
    createConversationInquirySuccess: (state, action: PayloadAction<any>) => {
      state.conversationInquiryData = action.payload;
      state.error = null;
    },
    createConversationInquiryFailure: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.conversationInquiryData = null;
      state.error = action.payload;
    },
    getConversationInquiryDetailSuccess: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.conversationInquiryDetailData = action.payload;
      state.error = null;
    },
    getConversationInquiryDetailFailure: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.conversationInquiryDetailData = null;
      state.error = action.payload;
    },
    cleanDataConversationInquiry: (state) => {
      state.conversationInquiryData = null;
      state.conversationInquiryDetailData = null;
      state.error = null;
    },
  },
});

export const {
  createConversationInquirySuccess,
  createConversationInquiryFailure,
  getConversationInquiryDetailSuccess,
  getConversationInquiryDetailFailure,
  cleanDataConversationInquiry,
} = conversationInquirySlice.actions;

export const createConversationInquiry =
  (inquiryData: any): AppThunk =>
  async (dispatch) => {
    dispatch(showLoading());
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.CONVERSATION_INQUIRY,
        {
          ...inquiryData,
        },
      );
      dispatch(createConversationInquirySuccess(response.data));
      return response.data;
    } catch (error: any) {
      dispatch(createConversationInquiryFailure(error.message));
      throw error;
    } finally {
      dispatch(hideLoading());
    }
  };

export const getConversationInquiryById =
  (conversationInquiryId: string): AppThunk =>
  async (dispatch) => {
    dispatch(showLoading());
    try {
      const response = await axiosInstance.get(
        API_ENDPOINTS.CONVERSATION_INQUIRY + "/" + conversationInquiryId,
      );
      dispatch(getConversationInquiryDetailSuccess(response.data));
      return response.data;
    } catch (error: any) {
      dispatch(getConversationInquiryDetailFailure(error.message));
      throw error;
    } finally {
      dispatch(hideLoading());
    }
  };

export default conversationInquirySlice.reducer;
